<template>
  <div class="wallet-cant-withdrawal">
    <p class="wallet-cant-withdrawal__title">
      {{ getContent(popupsData, defaultLocalePopupsData, 'wallet.withdraw.balanceInfo.yourFunds') }}
    </p>
    <p class="wallet-cant-withdrawal__info" v-html="DOMPurify.sanitize(info)" />
    <button-base type="primary" class="wallet-cant-withdrawal__btn" @click="goBonusPage">
      {{ getContent(layoutData, defaultLocaleLayoutData, 'buttons.openSettings') }}
    </button-base>
  </div>
</template>

<script setup lang="ts">
  import DOMPurify from 'isomorphic-dompurify';
  import { ModalName } from '@skeleton/consts/modals';

  const { popupsData, defaultLocalePopupsData, layoutData, defaultLocaleLayoutData } = storeToRefs(useGlobalStore());

  const { closeModalSync } = useModalStore();
  const { getContent, localizePath } = useProjectMethods();

  const goBonusPage = async () => {
    closeModalSync(ModalName.WALLET);
    await navigateTo(localizePath('/bonuses'));
  };

  const info = computed<string>(() => {
    let desc = getContent(popupsData.value, defaultLocalePopupsData.value, 'wallet.withdraw.balanceInfo.fundsInfo');

    if (desc) {
      desc = desc.replace('{url}', localizePath('/static/terms-and-conditions'));
    }

    return desc;
  });
</script>

<style src="~/assets/styles/components/wallet/cant-withdrawal.scss" lang="scss"></style>
